module.exports = __webpack_public_path__ + "static/media/webdesign-services-img66.fe26b5bd.jpg";